import * as React from 'react'
import { TextField } from '..'

type SearchInputProps = React.ComponentProps<typeof TextField>

export const SearchField: React.FC<SearchInputProps> = (props) => {
    return <TextField {...props} iconName="search" type="text" />
}
